import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { getSlateTypographyVariant } from "@faire/retailer-shared/SlateMappings/getSlateTypographyVariant";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import { getDecoratorValuesCSS } from "@faire/retailer/components/SDUI/ComponentRenderers/RichText/__internal__/richTextElementUtils";
export var SDUIRichTextRenderer = function(param) {
    var richTextElement = param.richTextElement;
    var segments = (richTextElement !== null && richTextElement !== void 0 ? richTextElement : {}).segments;
    if (!segments) {
        return null;
    }
    return /*#__PURE__*/ _jsx("span", {
        children: segments.map(function(segment, index) {
            return /*#__PURE__*/ _jsx(SDUIRichTextSegment, {
                segment: segment
            }, index);
        })
    });
};
var SDUIRichTextSegment = function(param) {
    var segment = param.segment;
    var content = segment.content, style = segment.style;
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Typography, {
        style: _object_spread({
            display: "inline"
        }, getDecoratorValuesCSS(style === null || style === void 0 ? void 0 : style.decorators)),
        color: getSlateColorToken(style === null || style === void 0 ? void 0 : style.color),
        variant: getSlateTypographyVariant(style === null || style === void 0 ? void 0 : style.type, style === null || style === void 0 ? void 0 : style.decorators),
        children: content
    });
};
